import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetSiteSAMLAuthSettingForEmbeddedViewsParams {
  authSetting: string;
}

export class SetSiteSAMLAuthSettingForEmbeddedViewsRequest extends Request<ISetSiteSAMLAuthSettingForEmbeddedViewsParams, ISiteSAMLConfiguration> {
  constructor(params: ISetSiteSAMLAuthSettingForEmbeddedViewsParams) {
    super('setSiteSAMLAuthSettingForEmbeddedViews', params);
  }
}
